module.exports = __webpack_public_path__ + "img/宁兴特钢.a79b6ba8.png";